/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState, useId } from 'react';
import classNames from 'classnames';
import IconArrowHead from '../../../../IconArrowHead/IconArrowHead';
import useIsMobile from '../../../../../hooks/useIsMobile';

import css from './PopoverFilter.module.css';

const PopoverFilter = ({ rootClassName, className, label, children, inputIcon, onToggle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [shouldRender, setShouldRender] = useState(true); // controls full unmount-on-mobile behavior
  const dropdownRef = useRef(null);
  const isMobile = useIsMobile();

  // stable drawer key so events can identify this instance
  const reactId = useId();
  const drawerKey = `popover-${reactId}`;

  // if not drawer mode, always render
  useEffect(() => {
    if (!isMobile) setShouldRender(true);
  }, [isMobile]);

  const toggleIsOpen = () => {
    setIsOpen(prev => {
      const next = !prev;

      return next;
    });
    onToggle?.();
  };

  const close = () => {
    setIsOpen(false);
  };

  // outside click — use 'click' so clicked element's handlers run first
  useEffect(() => {
    const handleClickOutside = e => {
      if (isOpen && dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        close();
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen, isMobile]);

  // If this instance is a drawer-like one and was told not to render, render nothing.
  if (isMobile && !shouldRender) return null;

  const classes = classNames(rootClassName || css.root, { [css.rootOpen]: isOpen }, className);

  return (
    <div className={classes} ref={dropdownRef} data-drawer={drawerKey}>
      <div className={css.filterHeader}>
        <button
          type="button"
          className={classNames(css.labelButton, { [css.labelButtonOpened]: isOpen })}
          onClick={toggleIsOpen}
          aria-expanded={isOpen}
        >
          <span className={css.labelButtonContent}>
            {inputIcon && <span className={css.icon}>{inputIcon}</span>}
            <span className={css.labelWrapper}>
              <span className={css.label}>{label}</span>
            </span>
            <span className={classNames(css.openSign, { [css.openSignLeft]: isMobile && isOpen })}>
              <IconArrowHead
                direction={!isMobile ? (isOpen ? 'up' : 'down') : isOpen ? 'left' : 'right'}
              />
            </span>
          </span>
        </button>
      </div>
      <div className={css.divider} />
      <div className={classNames(css.contentWrapper, { [css.contentClosed]: !isOpen })}>
        {children}
      </div>
    </div>
  );
};

export default PopoverFilter;
